const generateErrorMessage = (errors) => {
  console.warn(errors);
  if (Array.isArray(errors) && errors.length > 0) {
    return errors[0].message;
  }
  return "An unexpected error occurred";
};

export default generateErrorMessage;
